import React from 'react';
import { bool, elementType, func, oneOf } from 'prop-types';
import { Route } from 'react-router-dom';

import { isNil } from 'lodash';

import CircularProgress from '@material-ui/core/CircularProgress';

import UnauthorizedPage from '../containers/Global/UnauthorizedPage';
import { PermissionTypes } from '../helpers/permissions';
import usePermissions from '../hooks/usePermissions';

import defaultClasses from './ProtectedRoute.module.css';

const ProtectedRoute = ({
    component: Component,
    permissions,
    render,
    isEnabled,
    ...routeProps
}) => {
    const isAllowed = usePermissions(permissions);

    return (
        <Route
            {...routeProps}
            render={(props) => {
                // If the authorization state is indeterminate, render a
                // progress indicator
                if (isNil(isAllowed)) {
                    return (
                        <div className={defaultClasses.progressContainer}>
                            <CircularProgress />
                            <span className={defaultClasses.progressLabel}>
                                Loading Page...
                            </span>
                        </div>
                    );
                }
                if (isAllowed && isEnabled) {
                    if (render) {
                        return render(props);
                    }
                    return <Component {...props} />;
                }
                return <UnauthorizedPage message="This Company is disabled, please contact Key2Act Support for more information." />;
            }}
        />
    );
};

ProtectedRoute.defaultProps = {
    isEnabled: true
};

ProtectedRoute.propTypes = {
    component:   elementType,
    permissions: oneOf(PermissionTypes).isRequired,
    render:      func,
    isEnabled:   bool
};

export default ProtectedRoute;
